
// 公众号相关
import { shipinhaoArticleList, shipinhaoArticleView } from '@/zsm-api-new/shipinhao.js'
// 视频号相关
import {updateAllianceGood,updateShipinhaoGoodRatio,shipinhaoShopDelGood,findAllianceGood,createAllianceGood,updateGoodShipinhao,queryGoodShipinhao,saveGoodShipinhao,listingGoodShipinhao,delistingGoodShipinhao,findGoodShipinhao,getDistDetail,findDistShipinhao,findShipinhaoCategory,saveDistShipinhao,createGoodShipinhao,deleteDistShipinhao} from "@/zsm-api-new/shipinhaoShop"
const state = {

}

const mutations = {

}

const actions = {
     
/**
 * 更新联盟商品 
 * @param {data} 商品信息
 * @returns 
 */
updateAllianceGood({ commit }, info) {
  return new Promise((resolve, reject) => {
    updateAllianceGood(info).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
},      
/**
 * 更新商品佣金比例 
 * @param {data} (参照数据库)
 * @returns 
 */
  updateShipinhaoGoodRatio({ commit }, info) {
  return new Promise((resolve, reject) => {
    updateShipinhaoGoodRatio(info).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
},    
/**
 * 删除商品 
 * @param goodId 商品ID
 * @returns 
 */
shipinhaoShopDelGood({ commit }, info) {
  return new Promise((resolve, reject) => {
    shipinhaoShopDelGood(info).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
},    
/**
 * 新增联盟商品 
 * @param productId 商品ID
 * @returns 
 */
findAllianceGood({ commit }, info) {
  return new Promise((resolve, reject) => {
    findAllianceGood(info).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
},  
/**
 * 新增联盟商品 
 * @param {params} (参数参数参照数据库)
 * @returns 
 */
  createAllianceGood({ commit }, info) {
  return new Promise((resolve, reject) => {
    createAllianceGood(info).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
},
     /**
     * 修改商品 
     * @param goodId 商品ID
     * @returns 
     */
     listingGoodShipinhao({ commit }, info) {
      return new Promise((resolve, reject) => {
        listingGoodShipinhao(info).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
       /**
     * 修改商品 
     * @param goodId 商品ID
     * @returns 
     */
       delistingGoodShipinhao({ commit }, info) {
        return new Promise((resolve, reject) => {
          delistingGoodShipinhao(info).then(response => {
            resolve(response)
          }).catch(error => {
            reject(error)
          })
        })
      },
  
   /**
     * 修改商品 
     * @param {params} (参数参数参照数据库)
     * @returns 
     */
   updateGoodShipinhao({ commit }, info) {
        return new Promise((resolve, reject) => {
          updateGoodShipinhao(info).then(response => {
            resolve(response)
          }).catch(error => {
            reject(error)
          })
        })
      },

         /**
         * 查询商品 
         * @param  goodId 键ID
         * @returns 
         */
         queryGoodShipinhao({ commit }, info) {
          return new Promise((resolve, reject) => {
            queryGoodShipinhao(info).then(response => {
              resolve(response)
            }).catch(error => {
              reject(error)
            })
          })
        },
    /**
     * 查询商品 
     * @param {params} (参数参数参照数据库)
     * @returns 
     */
      findGoodShipinhao({ commit }, info) {
        return new Promise((resolve, reject) => {
          findGoodShipinhao(info).then(response => {
            resolve(response)
          }).catch(error => {
            reject(error)
          })
        })
      },
    /**
     * 创建商品 
     * @param {params} (参数参数参照数据库)
     * @returns 
     */
      createGoodShipinhao({ commit }, info) {
        return new Promise((resolve, reject) => {
          createGoodShipinhao(info).then(response => {
            resolve(response)
          }).catch(error => {
            reject(error)
          })
        })
      },
    /**
     * 保存商品 
     * @param {params} (参数参数参照数据库)
     * @returns 
     */
      saveGoodShipinhao({ commit }, info) {
        return new Promise((resolve, reject) => {
          saveGoodShipinhao(info).then(response => {
            resolve(response)
          }).catch(error => {
            reject(error)
          })
        })
      },
      
    /**
     * 删除达人
     * @param id 主键ID
     * @returns 
     */
    deleteDistShipinhao({ commit }, info) {
      return new Promise((resolve, reject) => {
        deleteDistShipinhao(info).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  /**
   * 查询达人详情
   * @param distId 主键ID
   * @returns 
   */
    getDistDetail({ commit }, info) {
      return new Promise((resolve, reject) => {
        getDistDetail(info).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    
    
    /**
     * 查询达人
     * @param distId 账号
     * @param distName 名字
     * @returns 
     */
      findDistShipinhao({ commit }, info) {
        return new Promise((resolve, reject) => {
          findDistShipinhao(info).then(response => {
            resolve(response)
          }).catch(error => {
            reject(error)
          })
        })
      },
  /**
   * 新增达人
   * @param distId 账号
   * @param distName 名字
   * @returns 
   */
    saveDistShipinhao({ commit }, info) {
      return new Promise((resolve, reject) => {
        saveDistShipinhao(info).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  /**
   * 
   * @param  id  类目ID
   * @param  level  类目层级 1 一级 2二级 3三级
   * @returns 
   */
  findShipinhaoCategory({ commit }, info) {
    return new Promise((resolve, reject) => {
      let  {id, level} = info;
      findShipinhaoCategory(id, level).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  

  // 公众号文章列表
  shipinhaoArticleList({ commit }, info) {
    return new Promise((resolve, reject) => {
      shipinhaoArticleList(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * 公众号文章列表(单个)
   * params id 文章编号
   */
  shipinhaoArticleView({ commit }, info) {
    return new Promise((resolve, reject) => {
      shipinhaoArticleView(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
